<script>
import List from '../../baseComponents/list'
import { OPEN_MODAL } from '../../variables'
export default {
	extends: List,
	data() {
		return {
			rowClick: (item) => {
				this.$router.push({ name: 'UserListDetail', params: { botId: item.bot, userListId: item._id } })
			},
			items: [
				{
					header: 'Nom',
					value: (item) => item.name,
					sort: 'name',
					filter: {
						 name: 'name'
					 }
				 },
				{ header: 'Nombre d\'utilisateurs', value: (item) => item.users.length, sort: false, filter: false },
				{
					header: 'Envoyer à une liste',
					value: (item) => {
						if (item.schedules && item.schedules.length > 0) {
							let date
							let begin = new Date(item.schedules[0].date)
							let end = new Date(item.schedules[0].date)
							for (let i = 0; i < item.schedules.length; i++) {
								date = new Date(item.schedules[i].date)
								if (date.getTime() > end.getTime()) {
									end = date
								}
								if (date.getTime() < begin.getTime()) {
									begin = date
								}
							}

							return `du ${this.$options.filters.formatDate(begin)} au ${this.$options.filters.formatDate(end)}`
						}
						return null
					},
					icon: (item) => !item.schedules || item.schedules.length === 0 ? 'send' : null,
					cellClick: (item) => {
						if (!item.schedules || item.schedules.length === 0) {
							this.$store.dispatch(OPEN_MODAL, { name: 'SendSubBot', params: { id: item._id } })
						}
					}
				}
			]
		}
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/userLists/userList.list.vue